import styled from "styled-components";

export const StyledInputContainer = styled.div`
    width: 90%;

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;

    label {
        font-weight: 400;
        font-size: 1rem;
        color: var(--color-white);
    }
`